var _rect, _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbnailPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 49,
    viewBox: "0 0 89 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 88.5,
    height: 48.5,
    fill: "#F8F8F8",
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0718 18.3333H37.929C37.5739 18.3333 37.2861 18.6318 37.2861 19V31C37.2861 31.3682 37.5739 31.6666 37.929 31.6666H52.0718C52.4269 31.6666 52.7147 31.3682 52.7147 31V19C52.7147 18.6318 52.4269 18.3333 52.0718 18.3333Z",
    fill: "#F8F8F8",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3316 24.1381L37.2861 28.3333L38 28.395V31H52V29.6049L52.7147 29.6667L49.3121 26.1381C49.2524 26.0762 49.1816 26.0271 49.1036 25.9936C49.0256 25.9601 48.942 25.9428 48.8575 25.9428C48.7731 25.9428 48.6895 25.9601 48.6115 25.9936C48.5335 26.0271 48.4627 26.0762 48.403 26.1381L46.7407 27.8619C46.681 27.9238 46.6101 27.9729 46.5321 28.0064C46.4541 28.0399 46.3705 28.0572 46.2861 28.0572C46.2017 28.0572 46.1181 28.0399 46.0401 28.0064C45.9621 27.9729 45.8912 27.9238 45.8316 27.8619L42.2407 24.1381C42.181 24.0762 42.1101 24.0271 42.0321 23.9936C41.9541 23.9601 41.8705 23.9428 41.7861 23.9428C41.7017 23.9428 41.6181 23.9601 41.5401 23.9936C41.4621 24.0271 41.3912 24.0762 41.3316 24.1381Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C48.3284 24 49 23.3284 49 22.5C49 21.6716 48.3284 21 47.5 21C46.6716 21 46 21.6716 46 22.5C46 23.3284 46.6716 24 47.5 24Z",
    fill: "#C4C4C4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailPlaceholder);
export default __webpack_public_path__ + "static/media/thumbnail-placeholder.e4113e553be6f70e6b2f6654bb22fc7b.svg";
export { ForwardRef as ReactComponent };